class SystemComparisonReviews extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-syscmp-play]');
      if (!trigger) return;
      e.preventDefault();
      const item = trigger.closest('[data-syscmp-item]');
      if (item) this.activate(item);
    });
  }

  activate(item) {
    if (item.hasAttribute('data-syscmp-activated')) return;
    const template = item.querySelector('[data-syscmp-template]');
    const media = item.querySelector('[data-syscmp-media]');
    if (!template || !media) return;

    media.replaceChildren(template.content.cloneNode(true));
    item.setAttribute('data-syscmp-activated', '');

    const video = media.querySelector('video');
    if (video) {
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    }
  }
}

if (!customElements.get('system-comparison-reviews')) {
  customElements.define('system-comparison-reviews', SystemComparisonReviews);
}
